const translate = {
  methods: {
    /**
     *
     * @param {string} name name of table
     * @param {string} type female | male
     * @returns empty table translated
     */
    getEmptyTableMessage(name, type = 'male', queryExecuted = true, queryButtonName, customText) {
      if (!queryExecuted) {
        const i18nParams = queryButtonName ? { name: queryButtonName } : null
        return this.$tc('tables.need_search', i18nParams ? 2 : 1, i18nParams)
      }

      if (customText) {
        return customText
      }

      return this.$t(`tables.empty_message.${type}`, { name: name.toLowerCase() })
    },

    /**
     *
     * @param {string} name name of table
     * @param {string} type female | male
     * @returns empty table translated
     */
    getEmptyTableAddMessage(name, type = 'male') {
      return this.$t(`tables.empty_message_add.${type}`, { name: name.toLowerCase() })
    },
  },
}

export default translate
